'use es6';

import PropTypes from 'prop-types';
import { getContentEmbedUIBaseURL } from '../../constants/embed';
import { jsx as _jsx } from "react/jsx-runtime";
function EmbedIframe(props) {
  const {
    inpage,
    embedId,
    style,
    iframeRef = () => {}
  } = props;
  const getSource = () => {
    const query = encodeURIComponent(`id=${embedId}&inpage=${inpage}&origin=${window.location.origin}`);
    return `${getContentEmbedUIBaseURL()}?${query}`;
  };
  const getKey = () => `hs-iframe-embed-${embedId}`;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("iframe", {
      "data-test-id": "hs-content-embed-iframe",
      style: style,
      contentEditable: false,
      src: getSource(),
      sandbox: "allow-scripts allow-same-origin",
      referrerPolicy: "strict-origin",
      ref: el => iframeRef(el)
    }, getKey())
  );
}
EmbedIframe.propTypes = {
  inpage: PropTypes.bool.isRequired,
  embedId: PropTypes.string.isRequired,
  style: PropTypes.object,
  iframeRef: PropTypes.func
};
export default EmbedIframe;